import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Calendar.scss";
import { parseDate } from "../utils/date";

const Calendar = () => {
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [events, setEvents] = useState([]);
    const [loadingEvents, setLoadingEvents] = useState(true);
    const [isMobile, setIsMobile] = useState(false);

    // Detect mobile screen size
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Fetch events from Google Calendar API
    useEffect(() => {
        const fetchEvents = async () => {
            try {
                setLoadingEvents(true);
                const response = await axios.get('/api/calendar-events/');
                // Handle both response formats: array or object with events property
                const eventsData = Array.isArray(response.data) 
                    ? response.data 
                    : (response.data.events || []);
                
                console.log('Fetched events:', eventsData.length, 'events');
                if (eventsData.length > 0) {
                    console.log('Sample event:', eventsData[0]);
                }
                
                setEvents(eventsData);
                setLoadingEvents(false);
            } catch (error) {
                console.error('Error fetching events:', error);
                setLoadingEvents(false);
                setEvents([]); // Ensure empty array on error
            }
        };

        fetchEvents();
    }, []);

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const getUpcomingEvents = () => {
        // Events are already filtered for upcoming by the API
        // Normalize date format and filter by category
        return events
            .map(event => ({
                ...event,
                // Ensure date is in YYYY-MM-DD format
                date: event.date ? (event.date.split('T')[0] || event.date) : event.date,
                // Ensure all required fields have defaults
                title: event.title || 'Untitled Event',
                time: event.time || 'All Day',
                location: event.location || 'TBD',
                description: event.description || '',
                type: event.type || 'meeting',
                id: event.id || event.title + event.date || Math.random().toString()
            }))
            .filter(event => event.date) // Filter out events without valid dates
            .filter(event => selectedCategory === 'all' || event.type === selectedCategory)
            .sort((a, b) => new Date(a.date) - new Date(b.date));
    };

    const getEventCountByCategory = (categoryKey) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to start of day for accurate comparison
        return events.filter(event => {
            if (!event.date) return false;
            try {
                const eventDate = parseDate(event.date);
                eventDate.setHours(0, 0, 0, 0);
                const isUpcoming = eventDate >= today;
                const matchesCategory = categoryKey === 'all' || event.type === categoryKey;
                return isUpcoming && matchesCategory;
            } catch {
                return false;
            }
        }).length;
    };

    const getEventTypeLabel = (type) => {
        const labels = {
            meeting: 'Monthly Meeting',
            sale: 'Fundraising Sale',
            cultural: 'Cultural Event',
            prayer: 'Prayer Service',
            planning: 'Planning Meeting'
        };
        return labels[type] || type;
    };

    const formatEventDate = (dateString) => {
        try {
            if (!dateString) return { day: '', month: '', weekday: '' };
            const date = parseDate(dateString);
            // Check if date is valid
            if (isNaN(date.getTime())) {
                console.warn('Invalid date:', dateString);
                return { day: '', month: '', weekday: '' };
            }
            return {
                day: date.getDate(),
                month: monthNames[date.getMonth()].substring(0, 3),
                weekday: date.toLocaleDateString('en-US', { weekday: 'long' })
            };
        } catch (error) {
            console.error('Error formatting date:', dateString, error);
            return { day: '', month: '', weekday: '' };
        }
    };

    const categories = [
        { key: 'all', label: 'All Events' },
        { key: 'meeting', label: 'Meetings' },
        { key: 'sale', label: 'Sales & Fundraising' },
        { key: 'cultural', label: 'Cultural Events' },
        { key: 'prayer', label: 'Prayer Services' },
        { key: 'planning', label: 'Planning & Committees' }
    ];

    return (
        <div className="calendar-page">
            {/* Event Categories Filter - Moved to top */}
            {/* <section className="event-categories">
                <div className="container">
                    <h2>Calendar of Events</h2> */}
                    {/* <p className="categories-description">
                        Filter events by category to find what interests you most
                    </p> */}
                    {/* <div className="category-filters">
                        {categories.map(category => {
                            const eventCount = getEventCountByCategory(category.key);
                            return (
                                <button
                                    key={category.key}
                                    className={`category-btn ${selectedCategory === category.key ? 'active' : ''}`}
                                    onClick={() => setSelectedCategory(category.key)}
                                >
                                    <span className="category-label">{category.label}</span>
                                    <span className="event-count">({eventCount})</span>
                                </button>
                            );
                        })}
                    </div> */}
                {/* </div>
            </section> */}

            {/* Google Calendar Section */}
            <section className="google-calendar-section ">
                <div className="container" style={{ paddingTop: '60px' }}>
                    <h2>Our Calendar</h2>
                    <div className="calendar-wrapper">
                        <iframe 
                            src={`https://calendar.google.com/calendar/embed?height=700&wkst=1&ctz=America%2FNew_York&showPrint=0&src=MDc2MjkxMmQzOTE1ZTBkNDUwMTlkNDA3YjA3MDQxYTcwMWU1ODcyNDQwN2YyZmJmZmIyNDhlZTY4MThiNDZlM0Bncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23039be5${isMobile ? '&mode=week&view=week' : ''}`}
                            style={{ border: 'solid 1px #777' }} 
                            width="1200" 
                            height="700" 
                            frameBorder="0" 
                            scrolling="no"
                            title="Ladies Guild Calendar"
                        ></iframe>
                    </div>
                </div>
            </section>

            {/* Upcoming Events */}
            {/* <section className="upcoming-events">
                <div className="container">
                    <div className="events-header">
                        <h2>Upcoming Events</h2>
                        {selectedCategory !== 'all' && (
                            <div className="active-filter-indicator">
                                <span className="filter-label">Showing:</span>
                                <span className="filter-category">
                                    {categories.find(cat => cat.key === selectedCategory)?.label}
                                </span>
                                <button 
                                    className="clear-filter-btn"
                                    onClick={() => setSelectedCategory('all')}
                                >
                                    ✕
                                </button>
                            </div>
                        )}
                    </div>
                    {loadingEvents ? (
                        <div className="loading-message">Loading events...</div>
                    ) : (
                        <div className="events-grid">
                            {getUpcomingEvents().length > 0 ? (
                                getUpcomingEvents().map((event, index) => {
                                const eventDate = formatEventDate(event.date);
                                return (
                                    <article key={event.id} className="event-card">
                                        <div className="event-card__content">
                                            <div className="event-date-badge">
                                                <span className="day">{eventDate.day}</span>
                                                <span className="month">{eventDate.month}</span>
                                            </div>
                                            <div className="event-meta">
                                                <span className="event-type">{getEventTypeLabel(event.type)}</span>
                                                <span className="event-weekday">{eventDate.weekday}</span>
                                            </div>
                                            
                                            <h3 className="event-title">{event.title}</h3>
                                            
                                            <div className="event-details">
                                                <div className="detail-item">
                                                    <span className="icon">🕐</span>
                                                    <span>{event.time}</span>
                                                </div>
                                                <div className="detail-item">
                                                    <span className="icon">📍</span>
                                                    <span>{event.location}</span>
                                                </div>
                                            </div>
                                            
                                            <p className="event-description">{event.description}</p>
                                            
                                            <button className="learn-more-btn">
                                                Learn More
                                            </button>
                                        </div>
                                    </article>
                                );
                            })
                            ) : (
                                <div className="no-events">
                                    <h3>No upcoming events in this category</h3>
                                    <p>Please check back soon or select a different category to see other events.</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </section> */}

            {/* Call to Action */}
            {/* <section className="calendar-cta">
                <div className="container">
                    <div className="cta-content">
                        <h2>Stay Connected</h2>
                        <p>
                            Don't miss out on our events! Follow us on social media or contact us 
                            directly to stay updated on all Ladies Guild activities and special announcements.
                        </p>
                        <div className="cta-buttons">
                            <button className="cta-btn primary">Join Our Mailing List</button>
                            <button className="cta-btn secondary">Contact Us</button>
                        </div>
                    </div>
                </div>
            </section> */}

            {/* Footer Note */}
            <div className="calendar-footer-note">
                <div className="container">
                    <p>
                        <em>Event information is regularly updated. For the most current details, 
                        please contact the church office at (201) 943-2950.</em>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Calendar;
